export type TestimonialFilter = "approved" | "rejected" | "all";

export const TESTIMONIAL_FILTERS: { id: TestimonialFilter; label: string }[] = [
  { id: "approved", label: "Approved" },
  { id: "rejected", label: "Rejected" },
  { id: "all", label: "All" },
];

const STATUS_FOR_FILTER = { approved: "APPROVED", rejected: "REJECTED" } as const;

export function filterTestimonials<T extends { status: string }>(
  rows: T[],
  filter: TestimonialFilter,
): T[] {
  if (filter === "all") return rows;
  return rows.filter(row => row.status === STATUS_FOR_FILTER[filter]);
}
